import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

interface ProductMeasure {
  id: number
  name: string
}

interface ProductVariation {
  id: number
  created_at: string
  product_id: number
  measurement: number
  amount: number
  sku: string
  inventory_count: number
  price: number
  sale_price: number
  updated_at: string
  color: string | null
  measure: ProductMeasure | null
}

const getProductVariations = async (productId: number | string) => {

  const { data, error } = await supabase
    .from('product_variations')
    .select(`
      *,
      measure:product_measures(*)
    `)
    .eq('product_id', productId)

  if (error) {
    console.error('Error fetching product variations:', error)
    throw new Error(error.message)
  }

  console.log('Found variations:', data)
  return data as ProductVariation[]
}

export default function useGetProductVariationsByProductId(productId: number | string) {
  return useQuery({
    queryKey: ['useGetProductVariationsByProductId', productId],
    queryFn: () => getProductVariations(productId),
    staleTime: 0,
    enabled: !!productId
  })
}